import { Amplify } from "aws-amplify"
import config from "./config"

export function configureAWSAmplify() {
    Amplify.configure(config)
}
